<template>
    <div class="templete_box">
        <div class="templete no_print">
            <div class="search_box search_box_f clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <!-- <el-select class="search_select search_inputBox" v-model="params.search.payee" placeholder="服务商名称" @visible-change="getSelectList('supplier')">
                    <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <!-- <el-input class="search_input search_inputBox" v-model="params.search.payee" placeholder="服务商名称"></el-input> -->
                <el-select class="search_select search_inputBox" v-model="params.search.payee" placeholder="服务商名称" @visible-change="getSelectList('servers')">
                    <el-option v-for="list in selectMap.servers" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
                
                <el-input class="search_input search_inputBox" v-model="params.search.contract_no" placeholder="合同号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.search.bill_lading_no" placeholder="提单号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.search.order_sn" placeholder="销售单号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.search.fee_sn" placeholder="费用单号"></el-input>
                <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.search.pay_type" placeholder="费用类型" @visible-change="getFeeType" @change="payType">
                    <el-option v-for="list in pay_typeList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" multiple collapse-tags v-model="params.search.fee_id" placeholder="费用名称" @visible-change="getFeeName">
                    <el-option v-for="list in feeType" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.invoice_status" placeholder="发票状态">
                    <el-option v-for="list in invoice_statusList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.pay_status" placeholder="付款状态">
                    <el-option v-for="list in pay_statusList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.creator_id" placeholder="制单人" @visible-change="creator">
                    <el-option v-for="list in creater" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>

                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',finance-fee-manage-add-cost,')!=-1" @click="addFee();addType=2;costTitle='添加成本费用'">添加成本费用</el-button>
                <el-button class="funcPublicBtn funcPublicBtnCost" v-if="module.indexOf(',finance-fee-manage-add,')!=-1" @click="addFee();addType=3;costTitle='添加营业支出费用'">添加营业支出费用</el-button>
                <el-button class="funcPublicBtn" @click="payment" v-if="module.indexOf(',finance-fee-manage-payment,')!=-1">批量付费</el-button>
                <el-button class="funcPublicBtn" @click="batchConfirmBill" v-if="module.indexOf(',finance-fee-manage-invoice,')!=-1">发票确认</el-button>
                <el-button class="funcPublicBtn" @click="batchDel" v-if="module.indexOf(',finance-fee-manage-delete,')!=-1">批量删除</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="fee.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick" @backClick="backClick"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber">成本费用：{{ statistics.fee_base }}</div>
                <div class="totalNumber">营业支出费用：{{ statistics.fee_other }}</div>
                <div class="totalNumber">已付金额：{{ statistics.pay_yes }}</div>
                <div class="totalNumber">抹零金额：{{ statistics.discount_amount }}</div>
                <div class="totalNumber" style="color:#ff0000">未付金额：{{ statistics.pay_no }}</div>
                <div class="totalNumber" v-if="selectAmount">选中费用金额: {{selectAmount}}</div>
            </div>
        </div>
        <!--添加费用START-->
        <el-dialog v-dialog-drag :visible.sync="isShowCost" class="eldialog eldialogLine" :modal="false" :title="costTitle" custom-class="full_dialog">
            <!-- <div class="selectAddType clearfix">
                <div class="typeBox">
                    <div :class="['typeName',addType==2?'typeNameChecked':'']" @click="addType=2">成本费用</div>
                </div>
                <div class="typeBox">
                    <div :class="['typeName',addType==3?'typeNameChecked':'']" @click="addType=3">营业外支出费用</div>
                </div>
            </div> -->
            <div class="dialogSearchBox" v-show="addType==2">
                <el-form ref="feeForm" :model="feeForm" :rules="feeFormRlues" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="feeForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item  label="合同号：" prop="contract_no">
                        <el-input v-model="feeForm.contract_no" readonly></el-input>
                    </el-form-item> -->
                    <el-form-item  label="合同号：" prop="contract_no">
                        <el-select v-model="feeForm.contract_no" clearable filterable @visible-change="contractNoChange('contract_no')">
                            <el-option v-for="(list,index) in contract_no_list" :key="index" :value="list" :label="list"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="提单号：" prop="bill_lading_no">
                        <el-select v-model="feeForm.bill_lading_no" filterable clearable @visible-change="contractNoChange('bill_lading_no')">
                            <el-option v-for="(list,index) in bill_lading_no_list" :key="index" :value="list" :label="list"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="货柜号：" prop="container_no">
                        <el-select v-model="feeForm.container_no" filterable clearable @visible-change="contractNoChange('container_no')">
                            <el-option v-for="(list,index) in container_no_list" :key="index" :value="list" :label="list"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="feeForm.fee_id"  @visible-change="getSelectList('purchaseCost')" clearable>
                            <el-option v-for="list in selectMap.purchaseCost" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="feeForm.payee" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item  label="金额(￥)：" prop="amount">
                        <el-input v-model="feeForm.amount" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item  label="是否开票：" prop="is_invoice">
                        <el-select v-model="feeForm.is_invoice">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="feeForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="isShowCost=!isShowCost" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="saveFee">确认</el-button>
                    </div>
                </el-form>
            </div>
            <div class="dialogSearchBox" v-show="addType==3">
                <el-form ref="feeOutForm" :model="feeOutForm"  :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <el-form-item  label="费用日期：">
                        <el-date-picker v-model="feeOutForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="feeOutForm.fee_id"  @visible-change="outFeeSelectFunc" clearable>
                            <el-option v-for="list in outFeeSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="feeOutForm.payee" placeholder="请输入服务商名称"></el-input>
                    </el-form-item>
                    <el-form-item  label="关联销售人：">
                        <el-select v-model="feeOutForm.salesman_id" filterable @visible-change="outSalesmanFunc" @change="outSalesmanChange" clearable>
                            <el-option v-for="list in salesman" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="关联客户名称：">
                        <el-select v-model="feeOutForm.customer_id" filterable @visible-change="outCustomerFunc" @change="outCustomerChange" clearable>
                            <el-option v-for="list in customer" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="关联销售单号：">
                        <el-select v-model="feeOutForm.order_id" filterable @visible-change="outOrderSnFunc" @change="outOrderSnChange" clearable>
                            <el-option v-for="list in orderSn" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="费用金额：" prop="amount">
                        <el-input v-model="feeOutForm.amount" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item  label="是否开票：" prop="invoice_status">
                        <el-select v-model="feeOutForm.invoice_status">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：">
                        <el-input v-model="feeOutForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="isShowCost=!isShowCost" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="saveOutFee">确认</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加费用END-->
        <!-- 付费 dialog START -->
        <el-dialog v-dialog-drag :title="fee_sn_show?'付费':'批量付费'" :visible.sync="addDialogVisible" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="合计应付金额：">
                        <el-input v-model="add_params.total" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="费用单号：" v-if="fee_sn_show">
                        <el-input v-model="add_params.fee_sn" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="付款日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="服务商名称：">
                        <el-input v-model="add_params.server_name" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="付费方式：">
                        <el-select v-model="add_params.payment_type_id" placeholder="请选择" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="付费账号：">
                        <el-select v-model="add_params.account_id" placeholder="请选择" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="add_params.bill_type" placeholder="" disabled>
                            <el-option :value="0"  label="收入"></el-option>
                            <el-option :value="1"  label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="add_params.course_title" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="付费金额：">
                        <el-input v-model="add_params.amount" @input="matchAmount" :class="matchAmountFlag?'matchAmount':''" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible=!addDialogVisible">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderSheet">确定</el-button>
            </div>
        </el-dialog>
        <!-- 付费 dialog END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="fee.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!--拒绝原因START-->
        <el-dialog v-dialog-drag title="拒绝原因" :visible.sync="centerDialogVisible" width="500px" class="eldialog eldialogA" :model="false" custom-class="full_dialog">
            <textarea class="edit_input edit_textarea" v-model="refuse_remark" placeholder="请输入拒绝原因" readonly></textarea>
		</el-dialog>
        <!--拒绝原因END-->
        <!--抹零金额START-->
        <el-dialog v-dialog-drag title="金额抹零" :visible.sync="moneyResetDialog" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="moneyData" :inline="true" ref="moneyForm" :rules="paymentRules" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="合计应付金额：" prop="amount">
                        <el-input v-model="moneyData.amount" ></el-input>
                    </el-form-item>
                    <el-form-item label="备注信息：">
                        <el-input class="edit_input edit_textarea" v-model="moneyData.remark"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="moneyResetDialog=!moneyResetDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="setMoneyData">确定</el-button>
            </div>
        </el-dialog>
        <!--抹零金额END-->

        <saledetail :dialogVisiblesale="dialogVisibleSale" :id="saleDetailId" @close="()=>{this.saleDetailId = false;}"></saledetail>
    </div>
</template>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    import saledetail from '../../components/saleDetail.vue'
    import selectDownCustomer from '../../components/selectDownCustomer.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                dialogVisibleSale:false,
                saleDetailId:"",

                module:localStorage.dw_erp_power_code,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                isShowMore:false,
                start_time:"",
                end_time: new Date(),
                params:{
                    search:{
                        start_time:"",
                        end_time: "",
                        payee:"",
                        creator_id:"",
                        contract_no:"",
                        bill_lading_no:"",
                        fee_id:"",
                        order_sn:"",
                        fee_sn:"",
                        pay_type:"",
                        invoice_status:"",
                        pay_status:"",
                        customer_id:""
                    },
                    page:1,
                    per_page:50
                },

                feeFormRlues:{
                    // fee_date:[ { required: true, message: '请填写日期', trigger: 'blur' }],
                    // contract_no:[ { required: true, message: '请填写合同号', trigger: 'blur' }],
                    // fee_id:[ { required: true, message: '请选择费用名称', trigger: 'change' }],
                    // payee:[ { required: true, message: '请填写收款人', trigger: 'blur' }],
                    // amount:[ { required: true, message: '请填写金额', trigger: 'blur' }],
                    // is_invoice:[ { required: true, message: '请选择是否开票', trigger: 'change' }],
                    fee_date:[ { required: true, message: ' ', trigger: 'blur' }],
                    contract_no:[ { required: true, message: ' ', trigger: 'blur' }],
                    fee_id:[ { required: true, message: ' ', trigger: 'change' }],
                    payee:[ { required: true, message: ' ', trigger: 'blur' }],
                    amount:[ { required: true, message: ' ', trigger: 'blur' }],
                    is_invoice:[ { required: true, message: ' ', trigger: 'change' }]
                },
                feeOutFormRlues:{
                    // fee_date:[ { required: true, message: '请填写日期', trigger: 'blur' }],
                    //order_id:[ { required: true, message: '请选择销售单号', trigger: 'blur' }], //modified by xiong
                    fee_id:[ { required: true, message: ' ', trigger: 'change' }],
                    payee:[ { required: true, message: ' ', trigger: 'blur' }],
                    amount:[ { required: true, message: ' ', trigger: 'blur' }],
                    invoice_status:[ { required: true, message: ' ', trigger: 'change' }]
                },
                paymentRules:{
                    course_name:[{required: true, message: '必填项', trigger: 'change' }],
                    amount:[{required: true, message: '必填项', trigger: 'change' }],
                },
                costTitle:"",
                last_page:1,
                total:0,
                addType:2,//成本费用2  营业外支出3
                isShowCost:false,
                addDialogVisible:false,
                trading_time:"",
                fee_sn_show:false,
                add_params : {
                    total:'',
                    fee_sn : "",
                    bill_type : "",
                    amount : "",
                    account_id : "",
                    server_name : "",
                    trading_time :"",
                    trading_mode_id : "",
                    course_title : "进销货款",
                    remark : ""
                },
                selectRow:[],
                selectMap:{
                    customer:[],
                    feeType:[],
                    creater:[],
                    purchaseCost:[],
                    paymentType:[],
                    account:[],
                    supplier:[],
                    servers:[]
                },
                creater:[],
                pay_typeList:[
                    {id:999,name:"全部付款类型状态"},
                    {id:1,name:"采购费用"},
                    {id:2,name:"营业支出"}
                ],
                feeType:[],
                invoice_statusList:[
                    {id:999,name:"全部发票状态"},
                    {id:1,name:"未开"},
                    {id:2,name:"已开"}
                ],
                pay_statusList:[
                    {id:999,name:"全部付款状态"},
                    {id:1,name:"未支付"},
                    {id:3,name:"部分支付"},
                    {id:2,name:"已支付"}
                ],
                container_no_list:[],
                bill_lading_no_list:[],
                contract_no_list:[],
                outFeeSelect:[],
                orderSn:[],
                customer:[],
                salesman:[],
                list:[],
                customer_dis:false,
                tableCol:[
                    {colName:"添加日期",colKey:"fee_date",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"审核状态",colKey:"auditor_status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,backClick:true},
                    {colName:"费用类型",colKey:"source_type_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"费用名称",colKey:"fee_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"费用金额",colKey:"amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"已付金额",colKey:"pay_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"未付金额",colKey:"un_pay_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"抹零金额",colKey:"discount_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,noZero:true},
                    {colName:"是否开票",colKey:"is_invoice_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"服务商名称",colKey:"payee",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"付款状态",colKey:"pay_status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"发票状态",colKey:"invoice_status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"费用单号",colKey:"fee_sn",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"费用单号",colKey:"fee_sn",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联销售单号",colKey:"order_sn",colWidth:170,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"关联客户名称",colKey:"customer_name",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联销售人",colKey:"salesman_name",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"审核人",colKey:"auditor_name",colWidth:140,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"付款人",colKey:"pay_operator_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},


                    // {colName:"货柜号",colKey:"container_no",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"费用日期",colKey:"fee_date",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"审核员",colKey:"auditor_name",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"审核日期",colKey:"audit_time",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                statistics:{},
                feeForm:{
                    fee_date:"",
                    purchase_id:"",
                    contract_no:"",
                    container_no :"",
                    bill_lading_no:"",
                    fee_id:"",
                    payee:"",
                    amount:"",
                    is_invoice:"",
                    remark:""
                },
                feeOutForm:{
                    fee_date:"",
                    fee_id:"",
                    payee:"",
                    amount:"",
                    invoice_status:"",
                    remark:"",
                    salesman_id:'',
                    customer_id:'',
                    order_id:"",
                    order_sn:""
                },
                filterDialogVisible:false,
                filter:"",
                fields:"",
                matchAmountFlag:false,
                centerDialogVisible:false,
                refuse_remark:"",
                moneyResetDialog:false,
                moneyData:{
                    id:'',
                    amount:'',
                    remark:''
                },
                selectAmount:'',
            }
        },
        created(){
            // window.console.log(this.$getCurrentMonthStartValueOf())
            // this.start_time = this.$getCurrentMonthStartValueOf() ;】
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        mounted(){
        },
        methods:{
            backClick(id){
                this.list.forEach(item=>{
                    if(id==item.id){
                        this.centerDialogVisible=true;
                        this.refuse_remark=item.refuse_remark;
                    }
                })
            },
            payType(){
                this.params.search.fee_id = [];
            },
            getFeeType(){
                this.postFunc("/erp/fee.type.select.types",{},res=>{
                    this.pay_typeList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getFeeName(){
                this.postFunc("/erp/fee.type.select",{types:this.params.search.pay_type},res=>{
                    this.feeType = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            exportExcelBill(){
                this.$exportExecl("/erp/export.fee.list","费用管理",this.params)
            },
            creator(){
                this.postFunc("/erp/fee.creators",{},res=>{
                    this.creater = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            outOrderSnFunc(){
                let {feeOutForm} = this.$data;
                let params = {
                    salesman_id:feeOutForm.salesman_id,
                    customer_id:feeOutForm.customer_id,
                }
                this.postFunc("/erp/finance.order.select",params,res=>{
                    this.orderSn = res.data.data;
                })
            },
            outOrderSnChange(e){
                // 获取当前选中销售单 渲染 客户 销售人
                let {orderSn} = this.$data;
                if(e){
                    orderSn.forEach(item=>{
                        if(item.id == e){
                            // 渲染销售人
                            this.salesman = [
                                {
                                    id:item.salesman_id,
                                    name:item.salesman_name,
                                }
                            ]
                            this.feeOutForm.salesman_id = item.salesman_id;
                            // 渲染客户名称
                            this.customer = [
                                {
                                    id:item.customer_id,
                                    name:item.customer_name,
                                    salesman_id:item.salesman_id,
                                    salesman_name:item.salesman_name,
                                }
                            ]
                            this.feeOutForm.customer_id = item.customer_id;
                            this.feeOutForm.order_id = item.id;
                        }
                    })
                }
            },

            outSalesmanFunc(){
                let {feeOutForm} = this.$data;
                let params = {
                    order_id:feeOutForm.order_id,
                    customer_id:feeOutForm.customer_id,
                }
                this.postFunc("/erp/finance.order.salesman.select",params,res=>{
                    this.salesman = res.data.data;
                })
            },
            outSalesmanChange(e){
                this.feeOutForm.order_id = "";
                this.feeOutForm.customer_id = "";
            },

            outCustomerFunc(){
                let {feeOutForm} = this.$data;
                let params = {
                    order_id:feeOutForm.order_id,
                    salesman_id:feeOutForm.salesman_id
                }
                this.postFunc("/erp/finance.order.customer.select",params,res=>{
                    this.customer = res.data.data;
                })
            },
            outCustomerChange(e){
                this.customer.forEach(item=>{
                    if(item.id == e){
                        this.salesman = [
                            {
                                id:item.salesman_id,
                                name:item.salesman_name,
                            }
                        ]
                        this.feeOutForm.salesman_id = item.salesman_id;
                    }
                })
            },

            matchAmount(val){
                if(Number(val)>Number(this.selectRow[0].amount)){
                    this.matchAmountFlag = true;
                }else{
                    this.matchAmountFlag = false;
                }
            },
            filterConfirm(){
                this.getList()
            },
            outFeeSelectFunc(){
                this.postFunc("/erp/purchase.cost.type",{type:2},res=>{
                    this.outFeeSelect=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //确认付费
            addOrderSheet(){
                if(Number(this.add_params.amount)>Number(this.add_params.amount)){
                    this.tip("付款金额不能大于费用金额！","warning")
                }else{
                    this.$confirm('是否确认付费?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.add_params.trading_time=this.formatTimeZero(this.trading_time)
                        this.postFuncLoading("/erp/fee.pay",this.add_params,()=>{
                            this.tip("添加成功","success")
                            this.addDialogVisible=false;
                            this.getList()
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            //付费
            payment(){
                let total = 0;
                let num = 0;
                let ids = [];
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning");
                    return
                }
                for(let i=0; i<this.selectRow.length;i++){
                    if(this.selectRow[0].payee !=this.selectRow[i].payee){
                        this.tip("批量付费，服务商必须相同！","warning");
                        return
                    }else{
                        ids.push(this.selectRow[i].id);
                        total += Number(this.selectRow[i].un_pay_amount);
                    }
                    num = i;
                }
                this.addDialogVisible = true;
                if(num >0){
                    this.fee_sn_show = false;
                    this.add_params.amount = this.keepLimit(total);
                    this.add_params.course_title="营业支出费用";
                }else{
                    this.fee_sn_show = true;
                    this.add_params.course_title=this.selectRow[0].fee_name;
                }
                this.add_params.ids = ids;
                this.add_params.total = this.keepLimit(total);
                this.add_params.fee_sn=this.selectRow[0].fee_sn;
                this.trading_time=this.selectRow[0].fee_date;
                this.add_params.bill_type=1;
                this.add_params.server_name=this.selectRow[0].payee;
                this.add_params.account_id=this.selectRow[0].account_id;
            },
            saveOutFee(){
                let time = this.feeOutForm.fee_date;
                this.feeOutForm.fee_date=this.formatTimeZero(this.feeOutForm.fee_date);
                this.orderSn.forEach(item=>{
                    if(item.id == this.feeOutForm.order_id){
                        this.feeOutForm.order_sn = item.name;
                    }
                })
                this.postFuncLoading("/erp/fee.add",this.feeOutForm,()=>{
                    this.isShowCost=!this.isShowCost;
                    this.tip("添加成功","success")
                    //this.getFeeList()
                    this.getList()
                    this.$refs['feeOutForm'].clearValidate()
                },error=>{
                    this.feeOutForm.fee_date = time;
                    this.tip(error.data.message,"warning")
                })
            },
            contractNoChange(target){
                this.getFeeDownMess(this.feeForm.contract_no,target,this.feeForm.bill_lading_no,this.feeForm.container_no)
                // this.getFeeDownMess(this.feeForm.contract_no,"container_no")
            },
            getFeeDownMess(contract_no,target,bill_lading_no,container_no){
                this.postFunc("/erp/fee.search.select",{contract_no:contract_no,target:target,bill_lading_no:bill_lading_no,container_no:container_no},res=>{
                    if(target=="bill_lading_no"){
                        this.bill_lading_no_list=res.data.data.result;
                    }else if(target=="contract_no"){
                        this.contract_no_list=res.data.data.result;
                    }else{
                        this.container_no_list=res.data.data.result;
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            addFee(){
                if(this.selectRow.length<1||this.selectRow.length>1){
                    // this.tip("请选择一条数据","warning")
                }else{
                    this.feeForm.contract_no=this.selectRow[0].contract_no;
                    this.getFeeDownMess(this.feeForm.contract_no,"bill_lading_no")
                    this.getFeeDownMess(this.feeForm.contract_no,"container_no")
                }
                this.isShowCost=!this.isShowCost;
                this.feeForm.fee_date=new Date();
                this.feeOutForm.fee_date=new Date();
            },
            //添加费用
            saveFee(){
                // this.feeForm.contract_no=this.selectRow[0].contract_no;
                let time = this.feeForm.fee_date;
                this.feeForm.fee_date=this.formatTimeZero(this.feeForm.fee_date);
                this.postFuncLoading("/erp/fee.cost.add",this.feeForm,()=>{
                    this.isShowCost=!this.isShowCost;
                    this.tip("添加成功","success")
                    this.getList()
                    //this.getFeeList()
                },error=>{
                    this.feeForm.fee_date = time;
                    this.tip(error.data.message,"warning")
                })
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            batchConfirmBill(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    this.$confirm('是否确认收到发票?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let arr = new Array();
                        this.selectRow.forEach(item=>{
                            arr.push(item.id)
                        })
                        this.postFuncLoading("/erp/fee.invoice.confirm",{ids:arr},()=>{
                            this.tip('确认成功','success');
                            this.getList()
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning");
                    return
                }
                let flag = false;
                this.selectRow.forEach(item=>{
                    if(item.pay_status !=0){
                        flag = true;
                    }
                })
                if(flag){
                    this.confirmLog('选中单子，存在已付款费用单！如果删除之前支付的金额回回到对应的账户余额里，确定删除吗？',()=>{
                        this.$confirm('是否删除?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            let arr = new Array();
                            this.selectRow.forEach(item=>{
                                arr.push(item.id)
                            })
                            let ids = arr.toString();
                            this.postFuncLoading("/erp/fee.delete",{ids:ids},()=>{
                                this.tip('删除成功','success');
                                this.getList()
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }).catch(()=>{});
                    })
                }else{
                    this.$confirm('是否删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let arr = new Array();
                        this.selectRow.forEach(item=>{
                            arr.push(item.id)
                        })
                        let ids = arr.toString();
                        this.postFuncLoading("/erp/fee.delete",{ids:ids},()=>{
                            this.tip('删除成功','success');
                            this.getList()
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            setMoneyData(){

            },
            reset(){
                // this.start_time = this.$getCurrentMonthStartValueOf();
                this.start_time = "";
                this.end_time = new Date();
                this.params={search:{start_time:"",end_time:"",payee:"",creator_id:"",contract_no:"",bill_lading_no:"",fee_id:"",fee_sn:"",pay_status:"",pay_type:"",invoice_status:"",customer_id:""},page:1,per_page:50};
                this.$refs['selectdowncustomer'].clearData()
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.start_time=this.formatTimeZero(this.start_time)
                this.params.search.end_time=this.formatTimeZero(this.end_time)
                this.tableLoading = true;
                this.$postColumnList("/erp/fee.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.list;
                    this.statistics = res.data.data.statistics;
                    this.list.forEach((item,index)=>{
                        item.isDelete=false;
                        item.idEdit=false;
                        if(item.fee_date!=0){
                            this.list[index].fee_date = this.formatTime(item.fee_date+"000")
                        }else{
                            this.list[index].fee_date = "";
                        }
                        if(item.audit_time!=0){
                            this.list[index].audit_time = this.formatTime(item.audit_time+"000")
                        }else{
                            this.list[index].audit_time =""
                        }
                        if(item.pay_status==1){
                            this.list[index].baseColor="";
                        }else{
                            this.list[index].baseColor="#ff0000";
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            // 获取抹零的信息
            getAmountMoney(id){
                this.moneyResetDialog = true;
                this.postFunc('/erp/fee.discount.get',{id:id},res=>{
                    this.moneyData = res.data.data;
                    this.moneyData.id = id;
                },err=>{

                })
            },
            setMoneyData(){
                this.$refs['moneyForm'].validate((valid) => {
                    if (valid) {
                        let {moneyData} = this.$data;
                        this.postFunc('erp/fee.discount.update',moneyData,res=>{
                            this.moneyResetDialog = false;
                            this.tip('抹零成功','success');
                            this.getList()
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }else{
                        return false
                    }
                })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name == "discount_amount"){
                    this.getAmountMoney(obj.row.id);
                }else{
                    this.list.forEach(item=>{
                        if(item.id == obj.id){
                            this.saleDetailId = item.order_id;
                        }
                        
                    })
                }
            },
            getRow(row){
                this.selectRow=row;
                let number = 0;
                this.selectRow.forEach(item=>{
                    number += Number(item.amount)
                })
                this.selectAmount = this.keepLimit(number)
            },
        },
        components:{
            tabletem,
            pagination,
            saledetail,
            selectDownCustomer
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "isShowCost":function(val){
                if(!val){
                    this.addType=2;
                    this.feeForm=this.resetJson(this.feeForm)
                    this.feeOutForm=this.resetJson(this.feeOutForm)
                }else{
                    if(this.$refs.feeForm){
                        this.$refs.feeForm.clearValidate()
                    }
                    if(this.$refs['feeOutForm']){
                        this.$refs['feeOutForm'].clearValidate()
                    }
                }
            },
            "addDialogVisible":function(val){
                if(!val){
                    this.add_params=this.resetJson(this.add_params)
                    this.add_params.course_title="进销货款";
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    .selectAddType{padding-bottom:15px;}
    .typeBox{width:50%;float: left;text-align: center;}
    .typeName{display: inline-block;padding-bottom:3px;font-size: 14px;cursor: pointer;}
    .typeNameChecked{border-bottom:2px solid #b21111;}
</style>
